module.exports = __webpack_public_path__ + "img/xuke1.5faf227d.png";